import { Component, computed, inject, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { DetailsValueComponent } from '@iw/common';
import { Currency } from '@iw/core/entities';

import {
  WithdrawalMethod,
  WithdrawalMethodId,
  WithdrawalReq,
} from '../../entities';
import { AdvcashDetailsComponent } from './advcash-details/advcash-details.component';
import { BankTransferInrDetailsComponent } from './bank-transfer-inr-details/bank-transfer-inr-details.component';
import { CardPersonalDetailsComponent } from './card-personal-details/card-personal-details.component';
import { PaypalDetailsComponent } from './paypal-details/paypal-details.component';
import { WithdrawalStore } from '../../withdrawal.store';
import { CryptoDetailsComponent } from './crypto-details/crypto-details.component';

@Component({
  selector: 'iw-withdrawal-details',
  imports: [
    DetailsValueComponent,
    TranslateModule,
    PaypalDetailsComponent,
    CardPersonalDetailsComponent,
    AdvcashDetailsComponent,
    BankTransferInrDetailsComponent,
    CryptoDetailsComponent,
  ],
  templateUrl: './withdrawal-details.component.html',
  styleUrl: './withdrawal-details.component.scss',
})
export class WithdrawalDetailsComponent {
  readonly #store = inject(WithdrawalStore);
  withdrawalInfo = input.required<WithdrawalReq>();
  currencyFrom = input.required<Currency>();
  currencyTo = input<Currency>();

  currencySymbol = computed(
    () =>
      this.currencyTo()?.symbol.toLowerCase() ||
      this.currencyFrom()?.symbol.toLowerCase(),
  );

  withdrawalMethodId = WithdrawalMethodId;

  get withdrawalMethod(): WithdrawalMethod {
    return this.#store
      .withdrawalMethods()
      .find((method) => this.withdrawalInfo().method === method.id);
  }
}
